import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import globals from "./global-variables";
import stylesConfig from "../styles.config";

export const CheckboxStyle = {
  padding: "5px",
  display: "none",
  "align-items": "center",
  "margin-right": "15px",
  "text-align": "center",
  content: "''",
  width: "15px",
  height: "15px",
  borderRadius: "3px",
  backgroundImage: (configuration: ResolvedComponentsConfiguration): string =>
    `${globals.customerSpriteTheme5(configuration)}`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "0px -103px",
  backgroundColor: stylesConfig.colors.secondary.spectrum100,
};

export const CheckboxStyleSelected = {
  ...CheckboxStyle,
  backgroundColor: stylesConfig.colors.primaryAccentColorVariants.default,
};
